import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { env } from '@/env';
import { Alert, Link } from '@/modules/ui';
import { ErrorCode } from '@/services/utilities/isApiError';

import * as felaRules from './LoginErrorAlert.rules';

export interface LoginErrorAlertProps {
    errorCode: string | null;
}

export const LoginErrorAlert = ({ errorCode }: LoginErrorAlertProps) => {
    const { css } = useFela(felaRules);

    switch (errorCode) {
        case ErrorCode.CONFIGURED_SUPER_ADMIN_USER_DOESNT_EXIST_IN_THE_WORKSPACE:
        case ErrorCode.CONFIGURED_SUPER_ADMIN_IS_NOT_AN_ADMIN:
            return <Alert type='error' message={<FormattedMessage id='error.auth.invalid-admin' />} rootClassName={css(felaRules.root)} />;
        case ErrorCode.AUTH_CLIENT_IS_NOT_CONFIGURED: {
            if (env.VITE_SAAS) {
                return (
                    <Alert
                        type='error'
                        message={
                            <FormattedMessage
                                id='error.auth.clientNotConfigured.saas'
                                values={{
                                    marketplaceLink: chunks => (
                                        <Link href={config.links.googleWorkspaceMarketplace} target='_blank' type='native' inheritColor>
                                            {chunks}
                                        </Link>
                                    ),
                                }}
                            />
                        }
                        rootClassName={css(felaRules.root)}
                    />
                );
            }
            return null;
        }
        default:
            return null;
    }
};
